module.exports = __webpack_public_path__ + "img/billy-freeman-koRmF1nz8iw-unsplash.b60cdce2.jpg";